import { useState } from 'react';
import { VIEW_MODE } from '../../consts/enums';
import TalentsEdit from '../TalentsPage/TalentsEdit';
import NewTalentDialog from './NewTalenDialog';

export const TalentNewPage = ():JSX.Element => {
  const [isOpenDialog, setDialogOpen] = useState<boolean>(true);
  const [data, setData] = useState<FormattedTalentResponse>({} as FormattedTalentResponse);
  const onTalentReady = (talent:FormattedTalentResponse) => {
    setData({
      ...talent,
    });
    setDialogOpen(false);
  };

  if (isOpenDialog) {
    return (
      <NewTalentDialog
        isShowDialog={ isOpenDialog }
        onTalentReady={ onTalentReady }
      />
    );
  }

  return <TalentsEdit data={ data } viewMode={ VIEW_MODE.EDITABLE } />;
};
